(() => {
  'use strict';
  if (window.__ngFestiveLoaded) return;
  window.__ngFestiveLoaded = true;
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = false;
  try { paused = sessionStorage.getItem('ng-effects-paused') === 'true'; } catch {}
  const fields = new Map();
  let frame = 0, last = 0;
  const buttons = () => document.querySelectorAll('[data-ng-effects-toggle]');
  function stopSnow() { cancelAnimationFrame(frame); frame = 0; last = 0; }
  function sizeField(field) {
    const { canvas, context, host } = field;
    const width = host ? host.clientWidth : document.documentElement.clientWidth;
    const height = host ? host.clientHeight : window.innerHeight;
    if (field.width === width && field.height === height) return;
    field.width = width;
    field.height = height;
    const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(width * ratio);
    canvas.height = Math.round(height * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    const count = host ? Math.min(width < 720 ? 28 : 62, Math.max(20, Math.round(width * height / 17000))) : width < 720 ? 24 : 44;
    field.flakes = Array.from({ length: count }, () => ({
      x: Math.random() * width, y: Math.random() * height,
      radius: .8 + Math.random() * 1.9, speed: 10 + Math.random() * 16,
      drift: 4 + Math.random() * 8, phase: Math.random() * Math.PI * 2,
      opacity: (host ? .42 : .26) + Math.random() * .46
    }));
  }
  const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(entries => {
    entries.forEach(entry => fields.forEach(field => { if (field.host === entry.target) sizeField(field); }));
  }) : null;
  function discoverSnow() {
    fields.forEach((field, canvas) => {
      if (canvas.isConnected) return;
      if (field.host) resizeObserver?.unobserve(field.host);
      fields.delete(canvas);
    });
    document.querySelectorAll('[data-ng-snow]').forEach(canvas => {
      if (fields.has(canvas)) return;
      const context = canvas.getContext('2d');
      if (!context) return;
      const host = canvas.hasAttribute('data-ng-snow-region') ? canvas.parentElement : null;
      const field = { canvas, context, host, width: 0, height: 0, flakes: [] };
      fields.set(canvas, field);
      sizeField(field);
      if (host) resizeObserver?.observe(host);
    });
  }
  function draw(now) {
    if (paused || reduced.matches || document.hidden) { stopSnow(); return; }
    frame = requestAnimationFrame(draw);
    if (last && now - last < 1000 / 30) return;
    const dt = last ? Math.min((now - last) / 1000, .06) : 0;
    last = now;
    const visibleRegions = [];
    fields.forEach(field => {
      if (!field.host) return;
      const rect = field.host.getBoundingClientRect();
      field.visible = rect.bottom > 0 && rect.top < window.innerHeight;
      if (field.visible) visibleRegions.push(rect);
    });
    fields.forEach(field => {
      const { context, width, height, flakes, host } = field;
      if (host && !field.visible) return;
      context.clearRect(0, 0, width, height);
      flakes.forEach(flake => {
      flake.y += flake.speed * dt;
      flake.x += Math.sin(now / 4200 + flake.phase) * flake.drift * dt;
      if (flake.y > height + 5) { flake.y = -5; flake.x = Math.random() * width; }
      if (flake.x < -5) flake.x = width + 5;
      if (flake.x > width + 5) flake.x = -5;
      context.beginPath();
      context.arc(flake.x, flake.y, flake.radius, 0, Math.PI * 2);
      context.fillStyle = `rgba(255,255,250,${flake.opacity})`;
      context.fill();
      });
      // Local fields provide denser snow on dark artwork; do not double it with the viewport field.
      if (!host) visibleRegions.forEach(rect => context.clearRect(rect.left, rect.top, rect.width, rect.height));
    });
  }
  function sync() {
    const inactive = paused || reduced.matches || document.hidden;
    root.dataset.ngEffectsPaused = String(inactive);
    buttons().forEach(button => {
      button.hidden = reduced.matches;
      button.setAttribute('aria-pressed', String(paused));
      button.querySelector('span').textContent = paused ? 'Play animations' : 'Pause animations';
    });
    fields.forEach(({ canvas }) => { canvas.hidden = reduced.matches; });
    if (!fields.size) return;
    if (inactive) stopSnow();
    else if (!frame) frame = requestAnimationFrame(draw);
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-ng-effects-toggle]')) return;
    paused = !paused;
    try { sessionStorage.setItem('ng-effects-paused', String(paused)); } catch {}
    sync();
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      entry.target.dataset.ngOffscreen = String(!entry.isIntersecting);
    }));
    document.querySelectorAll('[data-ng-festive]').forEach(element => observer.observe(element));
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ng-festive]').forEach(element => observer.observe(element)));
  }
  document.addEventListener('shopify:section:load', () => { discoverSnow(); sync(); });
  document.addEventListener('shopify:section:unload', () => { discoverSnow(); sync(); });
  let resizeTimer;
  window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(() => fields.forEach(sizeField), 140); }, { passive: true });
  document.addEventListener('visibilitychange', sync);
  window.addEventListener('pagehide', stopSnow);
  window.addEventListener('pageshow', sync);
  reduced.addEventListener?.('change', sync);
  discoverSnow();
  sync();
})();
